import '../../sass/pages/_newsDetail.scss'

// Import Swiper
import Swiper, { Navigation, Pagination } from 'swiper'
import 'swiper/css'
import 'swiper/css/navigation'
import 'swiper/css/pagination'

declare var drupalSettings: any;

document.addEventListener('DOMContentLoaded', (event) => {
    newsDetail()
})

const newsDetail = () => {
    modalGallery()
    setSwiper()
    relatedPost()
}

const relatedPost = async () => {
    let nodeID = drupalSettings.path.currentPath;
    let temp = nodeID.replace('node/','')
    let url = `/get/relatednews/${temp}`
    try {
        let res = await fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            }
        })
        const data = await res.json();
        await renderRelatedPosts(data)
    } catch (error) {
        console.log(error)
    }
}

const renderRelatedPosts = async (data : any) => {
    let _relatedPosts = await data;
    let containerRelated = document.getElementById('relatedPosts') as HTMLElement
    if(containerRelated != undefined ){
        containerRelated.innerHTML = ''
        _relatedPosts.map((rPost : any) => {
            let reNew = document.createElement('div')
            reNew.className = 'newsCard'
            let date = document.createElement('div')
            date.className = 'bold_18'
            date.textContent = rPost.textdate
            let title = document.createElement('div')
            title.className = 'subtitleSmall'
            title.textContent = rPost.news_title
            reNew.addEventListener('click', (e) => {
                window.location = rPost.url
            })
            reNew.appendChild(date)
            reNew.appendChild(title)
            containerRelated.appendChild(reNew)
        })
    }

}

const modalGallery = () => {
    const openModal = document.querySelector('.mvm__newsDetail__gallery .btn--solidWhite')
    const modalGallery = document.querySelector('.mvm-modal--swiper')
    const closeModal = modalGallery?.querySelector('.mvm-modal-close')
    const iframes = modalGallery?.querySelectorAll('iframe')

    openModal?.addEventListener('click', function () {
        modalGallery?.classList.remove('is-close')
        document.querySelector('body')?.classList.add('noScroll')
        if(iframes) {
            iframes.forEach((iframe) => {
                let iframeId = iframe.dataset.src
                iframe.src = `https://www.youtube.com/embed/${iframeId}`
            })
        }
    })
    
    closeModal?.addEventListener('click', function () {
        modalGallery?.classList.add('is-close')
        document.querySelector('body')?.classList.remove('noScroll')
        if (iframes) {
            iframes.forEach((iframe) => {
                iframe.src = ''
            })
        }
    })
}

const setSwiper = () => {
    const swiperModal = new Swiper('.swiper', {
        modules: [ Navigation, Pagination ],
        spaceBetween: 30,
        speed: 1000,
        direction: 'horizontal',
        loop: false,
        slidesPerView: 1,
        centeredSlides: true,
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        pagination: {
            el: '.swiper-pagination',
            type: 'fraction',
            formatFractionCurrent: function (number: any) {
                if (number <= '9') {
                    return '0' + number;
                } 
                
                else {
                    return number
                }
            },
            formatFractionTotal: function (number: any) {
                if (number <= '9') {
                    return '0' + number;
                } 
                
                else {
                    return number
                }
            },
        },
    })
}